(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/cdk/coercion')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/image-list', ['exports', '@angular/core', '@angular/cdk/coercion'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.imageList = {}), global.ng.core, global.ng.cdk.coercion));
}(this, (function (exports, core, coercion) { 'use strict';

    var MdcImageListItem = /** @class */ (function () {
        function MdcImageListItem(elementRef) {
            this.elementRef = elementRef;
        }
        MdcImageListItem.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcImageListItem], mdc-image-list-item',
                        exportAs: 'mdcImageListItem',
                        host: { 'class': 'mdc-image-list__item' }
                    },] }
        ];
        /** @nocollapse */
        MdcImageListItem.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcImageListItem;
    }());
    var MdcImageListImageAspect = /** @class */ (function () {
        function MdcImageListImageAspect(elementRef) {
            this.elementRef = elementRef;
        }
        MdcImageListImageAspect.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdcImageListImageAspect], mdc-image-list-image-aspect',
                        exportAs: 'mdcImageListImageAspect',
                        template: "\n  <div class=\"mdc-image-list__image-aspect-container\">\n    <ng-content></ng-content>\n  </div>\n  ",
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcImageListImageAspect.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcImageListImageAspect;
    }());
    var MdcImageListImage = /** @class */ (function () {
        function MdcImageListImage(elementRef) {
            this.elementRef = elementRef;
        }
        MdcImageListImage.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcImageListImage], mdc-image-list-image',
                        exportAs: 'mdcImageListImage',
                        host: { 'class': 'mdc-image-list__image' }
                    },] }
        ];
        /** @nocollapse */
        MdcImageListImage.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcImageListImage;
    }());
    var MdcImageListSupporting = /** @class */ (function () {
        function MdcImageListSupporting(elementRef) {
            this.elementRef = elementRef;
        }
        MdcImageListSupporting.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcImageListSupporting], mdc-image-list-supporting',
                        exportAs: 'mdcImageListSupporting',
                        host: { 'class': 'mdc-image-list__supporting' }
                    },] }
        ];
        /** @nocollapse */
        MdcImageListSupporting.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcImageListSupporting;
    }());
    var MdcImageListLabel = /** @class */ (function () {
        function MdcImageListLabel(elementRef) {
            this.elementRef = elementRef;
        }
        MdcImageListLabel.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcImageListLabel], mdc-image-list-label',
                        exportAs: 'mdcImageListLabel',
                        host: { 'class': 'mdc-image-list__label' }
                    },] }
        ];
        /** @nocollapse */
        MdcImageListLabel.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcImageListLabel;
    }());
    var MdcImageList = /** @class */ (function () {
        function MdcImageList(elementRef) {
            this.elementRef = elementRef;
            this._masonry = false;
            this._textProtection = false;
        }
        Object.defineProperty(MdcImageList.prototype, "masonry", {
            get: function () { return this._masonry; },
            set: function (value) {
                this._masonry = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcImageList.prototype, "textProtection", {
            get: function () { return this._textProtection; },
            set: function (value) {
                this._textProtection = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcImageList.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdc-image-list], mdc-image-list',
                        exportAs: 'mdcImageList',
                        host: {
                            'class': 'mdc-image-list',
                            '[class.mdc-image-list--masonry]': 'masonry',
                            '[class.mdc-image-list--with-text-protection]': 'textProtection'
                        },
                        template: '<ng-content></ng-content>',
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcImageList.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        MdcImageList.propDecorators = {
            masonry: [{ type: core.Input }],
            textProtection: [{ type: core.Input }]
        };
        return MdcImageList;
    }());

    var IMAGE_LIST_DECLARATIONS = [
        MdcImageList,
        MdcImageListImage,
        MdcImageListImageAspect,
        MdcImageListItem,
        MdcImageListLabel,
        MdcImageListSupporting
    ];
    var MdcImageListModule = /** @class */ (function () {
        function MdcImageListModule() {
        }
        MdcImageListModule.decorators = [
            { type: core.NgModule, args: [{
                        exports: IMAGE_LIST_DECLARATIONS,
                        declarations: IMAGE_LIST_DECLARATIONS,
                    },] }
        ];
        return MdcImageListModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcImageList = MdcImageList;
    exports.MdcImageListImage = MdcImageListImage;
    exports.MdcImageListImageAspect = MdcImageListImageAspect;
    exports.MdcImageListItem = MdcImageListItem;
    exports.MdcImageListLabel = MdcImageListLabel;
    exports.MdcImageListModule = MdcImageListModule;
    exports.MdcImageListSupporting = MdcImageListSupporting;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-image-list.umd.js.map
